import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import * as Icons from "react-icons/fa";
import logors from "../../assets/logo_rs.png";

const AppSidebar = ({ collapsed, isMobile, onCloseMobile, menus }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();

  const toggleMenu = (idMenu) => {
    setOpenMenus((prev) => ({ ...prev, [idMenu]: !prev[idMenu] }));
  };

  const renderIcon = (iconName) => {
    const Icon = Icons[iconName];
    return Icon ? <Icon className="text-base" /> : null;
  };

  const renderMenu = (menuList) =>
    menuList.map((menu) => {
      const isActive = menu.path && location.pathname === menu.path;
      const hasChildren = menu.children && menu.children.length > 0;

      const isChildActive =
        hasChildren &&
        menu.children.some((child) => location.pathname.startsWith(child.path));

      // const isChildActive =
      //   (hasChildren &&
      //     menu.children.some((child) =>
      //       location.pathname.startsWith(child.path),
      //     )) ||
      //   location.pathname.startsWith("/pages/pengadaan");

      const isOpen = openMenus[menu.idMenu] || isChildActive;

      const baseClass =
        "flex items-center justify-between gap-2 px-3 py-2.5 rounded-md transition-colors text-sm font-medium";

      const activeClass =
        "bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-l-4 border-blue-600";

      const hoverClass =
        "text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-800";

      const menuContent = (
        <div className="flex items-center gap-3">
          {renderIcon(menu.icon)}
          {!collapsed && <span>{menu.title}</span>}
        </div>
      );

      return (
        <div key={menu.idMenu} className="mb-1 relative group">
          {menu.path ? (
            <Link
              to={menu.path}
              onClick={isMobile ? onCloseMobile : undefined}
              className={`${baseClass} ${isActive ? activeClass : hoverClass}`}
            >
              {menuContent}
            </Link>
          ) : (
            <button
              onClick={() => toggleMenu(menu.idMenu)}
              className={`${baseClass} ${
                isChildActive ? activeClass : hoverClass
              } w-full`}
            >
              {menuContent}
              {!collapsed && hasChildren && (
                <span className="text-xs">{isOpen ? "▾" : "▸"}</span>
              )}
            </button>
          )}

          {/* Tooltip saat collapsed */}
          {collapsed && (
            <span
              className="absolute left-full top-1/2 -translate-y-1/2 ml-2
              px-3 py-1.5 rounded bg-gray-800 text-white text-sm shadow-lg
              whitespace-nowrap opacity-0 group-hover:opacity-100
              transition-opacity z-50"
            >
              {menu.title}
            </span>
          )}

          {/* Submenu */}
          {hasChildren && (
            <div
              className={`ml-4 border-l border-gray-300 dark:border-gray-700 pl-3
              overflow-hidden transition-all duration-300
              ${isOpen ? "max-h-96" : "max-h-0"}`}
            >
              {renderMenu(menu.children)}
            </div>
          )}
        </div>
      );
    });

  return (
    <>
      {isMobile && !collapsed && (
        <div
          className="fixed inset-0 bg-black/40 z-10"
          onClick={onCloseMobile}
        ></div>
      )}

      <div
        className={`fixed lg:relative z-20 h-full overflow-y-auto
        bg-slate-100 dark:bg-slate-900 border-r border-gray-300 dark:border-gray-700
        transition-all duration-300 ${collapsed ? "w-16" : "w-64"}`}
      >
        {/* Logo */}
        <div className="flex items-center gap-3 p-4 border-b border-gray-300 dark:border-gray-700">
          <img
            src={logors}
            alt="Logo"
            className={`h-12 transition-all duration-300 ${
              collapsed ? "mx-auto" : ""
            }`}
          />
        </div>

        {/* Menu */}
        <div className="p-2">{renderMenu(menus)}</div>
      </div>
    </>
  );
};

export default AppSidebar;
